// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"37e458f4","66":"2ed6bfd5","71":"bcb35f91","194":"596ecc17","205":"92e08592","365":"46ba36b5","418":"ac39fb08","488":"403d914d","626":"479db574","645":"8631013c","815":"d24b8da8","848":"aac63737","864":"ae542a1b","934":"a686cc57","936":"c7522417","965":"bd6a5bfe"}[chunkId] + ".chunk.js";
};